import { useDisclosure } from '@mantine/hooks';
import React, { useEffect, useRef, useState } from 'react'
import useCreate from '../useCreate';
import useDelete from '../useDelete';

function useStepRow(stepData, index, removeUnusedSteps, globalCurrency) {
    const isMounted = useRef(false)
    const {
        createMutation
    } = useCreate()

    const {
        deleteMutation
    } = useDelete()
    const [step, setStep] = useState(stepData ??
    {
        id: 1,
        name: "Step 1",
        fields: [
            { label: "Level", value: "", currency: "diamonds", fixed: true },
            { label: "Bonus Managers (optional)", value: "", currency: "eur" },
            { label: "Bonus Agents (optional)", value: "", currency: "eur" },
            { label: "Bonus Creators (optional)", value: "", currency: "eur" },
        ],
    },
    );

    useEffect(() => {

        if (globalCurrency && isMounted.current) {

            setStep(prev => ({
                ...prev,
                fields: step.fields.map((field, index) =>
                    !field.fixed ? { ...field, currency: globalCurrency } : field

                ),
            }))
        } else {
            isMounted.current = true
        }


    }, [globalCurrency]);

    const [opened, { open, close }] = useDisclosure(false);
    // Remove step
    const removeStep = (stepId) => {
        console.log({ stepId });

        if (typeof stepId === "number") {
            removeUnusedSteps(index);
            close();

            return;
        }
        const formData = new FormData();
        formData.append("id", stepData?.id);
        deleteMutation.mutate(formData)
        removeUnusedSteps(index);
        // setStep(prevSteps => {
        //     const updatedSteps = [...prevSteps]; // Create a copy
        //     updatedSteps.splice(index, 1); // Remove the step at the given index
        //     return updatedSteps; // Update state
        // });
        close();
    };

    // Save step
    const saveStep = (stepId) => {
        stepData = step;
        const formData = new FormData();
        formData.append("id", stepData?.id);
        formData.append("name", stepData?.name);
        formData.append("level", stepData?.fields[0]?.value);
        formData.append("bonus_manager", stepData?.fields[1]?.value);
        formData.append("bonus_manager_currency", stepData?.fields[1]?.currency);
        formData.append("bonus_agent", stepData?.fields[2]?.value);
        formData.append("bonus_agent_currency", stepData?.fields[2]?.currency);
        formData.append("bonus_creator", stepData?.fields[3]?.value);
        formData.append("bonus_creator_currency", stepData?.fields[3]?.currency);
        createMutation.mutate(formData)

        // alert(`Step ${stepData?.name} saved successfully!`);
    };


    // Handle currency change for an individual field
    const handleCurrencyChange = (stepId, fieldIndex, newCurrency) => {
        setStep(
            prev => (
                {
                    ...prev,
                    fields: step.fields.map((field, index) =>
                        index === fieldIndex && !field.fixed ? { ...field, currency: newCurrency } : field
                    ),
                }
            )
        );
    };




    // Handle input change for fields
    const handleInputChange = (stepId, fieldIndex, newValue) => {

        setStep(
            prev => (
                {
                    ...prev,
                    fields: step.fields.map((field, index) =>
                        index === fieldIndex ? { ...field, value: newValue } : field
                    ),
                }
            )
        )
    };

    // Rename a step
    const renameStep = (stepId) => {
        const newName = prompt("Enter new step name:");
        if (newName) {
            setStep(
                prev => (
                    {
                        ...prev,
                        name: newName,
                    }
                )
            )
        }
    };

    return {
        step,
        setStep,
        opened,
        open,
        close,
        removeStep,
        saveStep,
        handleCurrencyChange,
        handleInputChange,
        renameStep,
    }
}

export default useStepRow
